import React from "react";

const Scroller = () => {
  const scrollToTop = () => {
    if (window) window.scrollTo(0, 0);
  };
  return (
    <div className="scroll-to-top-wrapper">
        <div onClick={scrollToTop} className="scroll-to-top" aria-label="Scroll to Top"><i className="arrow-up"></i></div>
    </div>
  )
};

export default Scroller;